export default __webpack_public_path__ + "static/media/halls-1.9649d989.webp";